module.exports = __webpack_public_path__ + "img/section_icon_1.93952965.svg";